import { TrendingUp, AlertTriangle, Mail, Target, Clock, Users } from "lucide-react";

export const ColdEmailKeyFindings = () => {
  const findings = [
    {
      icon: <Mail className="w-5 h-5" />,
      stat: "50-100",
      label: "optimal daily sends per domain",
      description: "Exceeding this consistently triggers spam filters and damages reputation"
    },
    {
      icon: <TrendingUp className="w-5 h-5" />,
      stat: "65%",
      label: "achievable open rate",
      description: "With proper warmup, authentication, and personalization"
    },
    {
      icon: <Target className="w-5 h-5" />,
      stat: "3-5%",
      label: "average reply rate",
      description: "Top performers hit 8-10% with hyper-targeted lists"
    },
    {
      icon: <AlertTriangle className="w-5 h-5" />,
      stat: "< 0.1%",
      label: "max spam complaint rate",
      description: "Above this threshold triggers immediate filtering"
    },
    {
      icon: <Clock className="w-5 h-5" />,
      stat: "4-8 weeks",
      label: "domain warmup period",
      description: "New domains need gradual volume increase before scaling"
    },
    {
      icon: <Users className="w-5 h-5" />,
      stat: "3+",
      label: "domains for serious outreach",
      description: "Domain rotation protects reputation and increases deliverability"
    }
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-8 text-center">
        Key Cold Email Metrics
      </h2>
      
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {findings.map((finding, index) => (
          <div key={index} className="bg-card rounded-xl border border-border p-5 hover:border-primary/30 transition-colors">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary flex-shrink-0">
                {finding.icon}
              </div>
              <div>
                <div className="flex items-baseline gap-2 mb-1">
                  <span className="text-xl font-bold text-foreground">{finding.stat}</span>
                  <span className="text-xs text-muted-foreground">{finding.label}</span>
                </div>
                <p className="text-sm text-muted-foreground">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
